// Уведомления и живой канал. Формы — зеркало contracts/openapi/bark-core.v1.yaml.
//
// Правило одно и главное: **кадр живого канала не несёт данных**. Он говорит «появилось новое,
// наибольший номер такой-то», а содержимое берётся этой лентой. Иначе правило видимости жило бы
// в двух местах сразу — в выборке сервера и в разборе кадра, — и разъехалось бы молча.

import { request } from '@/shared/api/client';
import { queryString } from '@/shared/api/query';

export interface NotificationItem {
  id: string;
  /**
   * Номер доставки. Монотонный, но НЕ обязательно непрерывный: разрыв — повод сходить за
   * разницей, а не утверждение о потере.
   */
  seq: number;
  type_code: string;
  type_title: string;
  title: string;
  body?: string | null;
  payload?: Record<string, unknown> | null;
  /** Сущность перехода: cash_request, expense_claim, cash_issue, payroll… */
  entity?: string | null;
  entity_id?: string | null;
  created_at: string;
  read_at?: string | null;
}

export interface NotificationFeed {
  items: NotificationItem[];
  unread: number;
  /** Наибольший номер получателя. Ноль — первое знакомство, а не потеря. */
  high_water: number;
  generated_at: string;
}

export interface ReadResult {
  marked: number;
  unread: number;
}

export interface FeedParams {
  /** Догон: вернуть появившееся ПОСЛЕ этого номера, по возрастанию. */
  since_seq?: number;
  limit?: number;
  only_unread?: boolean;
}

export function fetchNotifications(params: FeedParams = {}): Promise<NotificationFeed> {
  return request<NotificationFeed>(`/api/v1/notifications${queryString({ ...params })}`);
}

export function markNotificationsRead(ids: string[]): Promise<ReadResult> {
  return request<ReadResult>('/api/v1/notifications/read', { method: 'POST', body: { ids } });
}

export function markAllNotificationsRead(): Promise<ReadResult> {
  return request<ReadResult>('/api/v1/notifications/read-all', { method: 'POST' });
}
